<div class="eco-page">
  <!-- Header Institucional -->
  <header class="eco-header flex align-items-center justify-content-between">
    <div class="flex align-items-center gap-3">
      <div class="eco-brand-badge eco-brand-badge--home">
        <img src="assets/ecodados-symbol.svg" alt="Símbolo EcoDados">
      </div>
      <h1 class="eco-title text-lg my-0">EcoDados <span class="font-normal text-600">| Minhas Tarefas</span></h1>
    </div>

    <div class="flex align-items-center gap-2">
      <nav class="hidden md:flex eco-nav">
        <a routerLink="/coletas" routerLinkActive="active" class="eco-nav-link">Minhas Coletas</a>
        @if (role() === 'ADMIN') {
          <a routerLink="/indicadores" routerLinkActive="active" class="eco-nav-link">Painel Admin</a>
          <a routerLink="/analytics" routerLinkActive="active" class="eco-nav-link">Gráficos</a>
        }
      </nav>

      <p-button icon="pi pi-sign-out" [text]="true" [rounded]="true" severity="secondary" (onClick)="logout()" pTooltip="Sair do sistema" styleClass="hidden md:inline-flex" />

      <!-- Botão Menu Mobile -->
      <p-button icon="pi pi-bars" [text]="true" [rounded]="true" severity="secondary" styleClass="md:hidden" (onClick)="showMobileMenu.set(true)" aria-label="Abrir menu de navegação" />
    </div>
  </header>

  <main class="eco-container flex flex-column gap-4">
    <!-- Welcome Banner Institucional -->
    <div class="eco-banner">
      <div class="relative z-1">
        <h2 class="eco-title text-white text-2xl mb-1 mt-0">Olá, {{ authService.currentUser()?.name }}!</h2>
        <p class="text-white-alpha-90 text-sm font-medium my-0">
          Você tem <span class="text-white font-bold">{{ tasks().length }} {{ tasks().length === 1 ? 'coleta pendente' : 'coletas pendentes' }}</span> aguardando preenchimento.
        </p>
      </div>
    </div>

    <!-- Toolbar: Tabs & Admin Action -->
    <div class="flex flex-column md:flex-row md:align-items-center justify-content-between gap-3">
      <!-- Tabs -->
      <div class="eco-toolbar">
        <button 
          (click)="setTab('pendentes')" 
          [class.active]="activeTab() === 'pendentes'" 
          class="eco-tab-button flex align-items-center gap-2">
          <span>Pendentes</span>
          @if (tasks().length > 0) {
            <span class="eco-badge-count">
              {{ tasks().length }}
            </span>
          }
        </button>

        <button 
          (click)="setTab('concluidas')" 
          [class.active]="activeTab() === 'concluidas'" 
          class="eco-tab-button flex align-items-center gap-2">
          <span>Coletas Concluídas</span>
        </button>

        @if (role() === 'ADMIN') {
          <button 
            (click)="setTab('historico_alteracoes')" 
            [class.active]="activeTab() === 'historico_alteracoes'" 
            class="eco-tab-button flex align-items-center gap-2">
            <span>Histórico de Alterações</span>
          </button>
        }
      </div>

      <!-- Admin Insertion Button -->
      @if (role() === 'ADMIN') {
        <p-button 
          label="Lançar Coleta Histórica" 
          icon="pi pi-plus-circle" 
          severity="secondary" 
          [outlined]="true"
          size="small" 
          [rounded]="true" 
          styleClass="w-full md:w-auto"
          (onClick)="openInsertModal()" />
      }
    </div>

    <!-- Filter Bar -->
    <div class="eco-filter-panel flex flex-column md:flex-row md:align-items-end gap-3">
      <!-- Filter by Indicator -->
      <div class="flex-1 flex flex-column gap-1">
        <label class="eco-label">Filtrar por Indicador</label>
        <select 
          [ngModel]="filterIndicatorId()" 
          (ngModelChange)="filterIndicatorId.set($event)"
          class="eco-input">
          <option value="">Todos os Indicadores</option>
          @for (ind of indicators(); track ind.id) {
            <option [value]="ind.id">[{{ ind.sigla }}] {{ ind.nome }}</option>
          }
        </select>
      </div>

      <!-- Filter by Month — PrimeNG DatePicker -->
      <div class="flex-1 md:max-w-15rem flex flex-column gap-1">
        <label class="eco-label">Filtrar por Mês</label>
        <p-datepicker
          [ngModel]="filterMonthDate()"
          (ngModelChange)="onMonthSelect($event)"
          view="month"
          dateFormat="MM/yy"
          placeholder="Selecione o mês"
          [showIcon]="true"
          [readonlyInput]="true"
          styleClass="w-full"
          inputStyleClass="eco-input" />
      </div>

      <!-- Clear Filters -->
      <div class="flex align-items-end">
        @if (filterIndicatorId() || filterMonth()) {
          <p-button label="Limpar Filtros" icon="pi pi-filter-slash" severity="secondary" size="small" [rounded]="true" (onClick)="clearFilters()" />
        }
      </div>
    </div>

    <!-- Main Content Tab View -->
    @if (loading()) {
      <div class="flex flex-column align-items-center justify-content-center py-6 gap-3">
        <div class="w-3rem h-3rem border-circle border-3 border-teal-200 border-t-teal-700 eco-spin"></div>
        <p class="eco-meta">Carregando coletas...</p>
      </div>
    } @else {
      <!-- 1. ABA PENDENTES -->
      @if (activeTab() === 'pendentes') {
        <div class="flex flex-column gap-3">
          @for (task of filteredTasks(); track (task.coletaId + '_' + $index)) {
            <article class="eco-card flex flex-column md:flex-row md:align-items-center justify-content-between gap-4">
              <div class="flex flex-column gap-2 flex-1">
                <div class="flex align-items-center gap-2 flex-wrap">
                  <p-tag [value]="task.sigla" severity="info" [rounded]="true" />
                  <p-tag [value]="formatReference(task)" severity="secondary" [rounded]="true" />
                  @if (isExpired(task.mesAno)) {
                    <p-tag value="Atrasado" severity="danger" [rounded]="true" />
                  }
                </div>

                <h3 class="eco-card-title my-0">
                  {{ task.nome }}
                </h3>

                <p class="eco-meta flex align-items-center gap-2 my-0">
                  <span class="material-symbols-outlined text-sm text-teal-700">schedule</span>
                  Prazo de envio: <span class="font-bold text-800">{{ getDeadline(task.mesAno) }}</span>
                </p>
              </div>

              <!-- Input & Action Area -->
              <div class="eco-value-panel flex align-items-center gap-3 justify-content-between md:justify-content-end self-stretch md:self-center">
                <div class="flex flex-column gap-1 align-items-start md:align-items-end">
                  <span class="eco-label">Valor ({{ task.unidade }})</span>
                  <input 
                    type="number" 
                    [(ngModel)]="task.valor" 
                    placeholder="0.00" 
                    class="eco-input w-8rem text-right font-bold text-teal-800">
                </div>

                <p-button 
                  label="Salvar" 
                  icon="pi pi-check" 
                  severity="primary" 
                  size="small" 
                  [rounded]="true" 
                  [disabled]="task.valor === null || task.valor === undefined || submittingId() === task.coletaId" 
                  [loading]="submittingId() === task.coletaId" 
                  (onClick)="openConfirmation(task)" />
              </div>
            </article>
          } @empty {
            <div class="text-center py-6 bg-white border-round-xl border-1 border-dashed border-teal-200 flex flex-column align-items-center gap-2">
              <span class="material-symbols-outlined text-5xl text-400">task_alt</span>
              <p class="font-bold text-base text-800 my-0">Tudo em dia!</p>
              <p class="eco-meta my-0">Nenhuma coleta pendente no momento com os filtros selecionados.</p>
            </div>
          }
        </div>
      }

      <!-- 2. ABA COLETAS CONCLUÍDAS -->
      @if (activeTab() === 'concluidas') {
        <div class="flex flex-column gap-3">
          @for (task of filteredHistoricalTasks(); track (task.coletaId + '_' + $index)) {
            <article class="eco-card flex flex-column md:flex-row md:align-items-center justify-content-between gap-4">
              <div class="flex flex-column gap-2 flex-1">
                <div class="flex align-items-center gap-2 flex-wrap">
                  <p-tag [value]="task.sigla" severity="info" [rounded]="true" />
                  <p-tag [value]="formatReference(task)" severity="secondary" [rounded]="true" />
                  <p-tag value="Concluído" severity="success" [rounded]="true" />
                </div>

                <h3 class="eco-card-title my-0">
                  {{ task.nome }}
                </h3>
              </div>

              <!-- Value / Edit Mode -->
              <div class="flex align-items-center gap-3 self-end md:self-center">
                @if (editingHistoryId() === task.coletaId) {
                  <div class="eco-value-panel flex align-items-center gap-2">
                    <input 
                      type="number" 
                      [(ngModel)]="editingValue" 
                      placeholder="0.00" 
                      class="eco-input w-7rem text-right font-bold text-teal-800">
                    <p-button icon="pi pi-check" severity="success" size="small" [rounded]="true" (onClick)="openConfirmationHistorical(task)" />
                    <p-button icon="pi pi-times" severity="secondary" size="small" [rounded]="true" [text]="true" (onClick)="cancelEditHistorical()" />
                  </div>
                } @else {
                  <div class="text-right">
                    <span class="eco-label block">Valor Registrado</span>
                    <span class="text-lg font-bold text-teal-800">{{ task.valor }} <span class="eco-meta font-normal">{{ task.unidade }}</span></span>
                  </div>
                  <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" severity="secondary" size="small" (onClick)="editHistoricalTask(task)" pTooltip="Editar valor informado" />
                }
              </div>
            </article>
          } @empty {
            <div class="text-center py-6 bg-white border-round-xl border-1 border-dashed border-teal-200 flex flex-column align-items-center gap-2">
              <span class="material-symbols-outlined text-5xl text-400">history</span>
              <p class="font-bold text-base text-800 my-0">Nenhum histórico encontrado</p>
              <p class="eco-meta my-0">As coletas concluídas aparecerão aqui.</p>
            </div>
          }
        </div>
      }

      <!-- 3. ABA HISTÓRICO DE ALTERAÇÕES -->
      @if (activeTab() === 'historico_alteracoes') {
        <div class="flex flex-column gap-3">
          <div class="text-center py-6 bg-white border-round-xl border-1 border-dashed border-teal-200 flex flex-column align-items-center gap-2">
            <span class="material-symbols-outlined text-5xl text-400">manage_search</span>
            <p class="font-bold text-base text-800 my-0">Trilha de Auditoria das Coletas</p>
            <p class="eco-meta max-w-26rem mx-auto my-0">
              Todas as inserções e alterações de coletas ficam devidamente registradas e rastreadas na base de dados institucional.
            </p>
          </div>
        </div>
      }
    }
  </main>

  <!-- Modal de Confirmação de Envio -->
  <p-dialog 
    header="Confirmar Envio" 
    [visible]="taskToConfirm() !== null" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '420px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="cancelConfirm()">
    
    <div class="flex flex-column gap-3 pt-2">
      <p class="eco-meta line-height-3 my-0">
        Você está enviando o valor <b class="text-teal-800 font-bold">{{ taskToConfirm()?.valor }} {{ taskToConfirm()?.unidade }}</b> para a coleta do indicador:
      </p>

      <div class="eco-card-low">
        <p class="text-sm font-bold text-800 my-0">{{ taskToConfirm()?.nome }}</p>
        <p class="eco-meta mt-1 mb-0">Referência: <b>{{ formatReference(taskToConfirm()) }}</b></p>
      </div>

      <div class="flex justify-content-end gap-2 pt-2">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="cancelConfirm()" />
        <p-button 
          label="Confirmar" 
          icon="pi pi-check" 
          severity="primary" 
          size="small" 
          [loading]="submittingId() !== null" 
          (onClick)="confirmSave()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Lançamento de Coleta Histórica (ADMIN) -->
  <p-dialog 
    header="Lançar Coleta Histórica" 
    [(visible)]="showInsertModal" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '480px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeInsertModal()">
    
    <div class="flex flex-column gap-3 pt-2">
      @if (insertError()) {
        <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-semibold flex align-items-center gap-2">
          <span class="material-symbols-outlined text-sm text-red-600">error</span>
          <span>{{ insertError() }}</span>
        </div>
      }

      <div class="flex flex-column gap-1">
        <label class="eco-label">Indicador *</label>
        <select 
          [ngModel]="insertForm().indicadorId" 
          (ngModelChange)="selectInsertIndicator($event)"
          class="eco-input">
          <option value="" disabled selected>Selecione o indicador...</option>
          @for (ind of activeIndicators(); track ind.id) {
            <option [value]="ind.id">[{{ ind.sigla }}] {{ ind.nome }}</option>
          }
        </select>
      </div>

      <div class="flex flex-column gap-1">
        <label class="eco-label">{{ selectedInsertIndicator()?.periodicidade === 'ANUAL' ? 'Ano de Referência *' : 'Mês / Ano de Referência *' }}</label>
        <input 
          [type]="selectedInsertIndicator()?.periodicidade === 'ANUAL' ? 'number' : 'month'"
          [min]="selectedInsertIndicator()?.periodicidade === 'ANUAL' ? 1900 : null"
          [max]="selectedInsertIndicator()?.periodicidade === 'ANUAL' ? 2100 : null"
          [ngModel]="insertForm().mesAno" 
          (ngModelChange)="insertForm.set({ indicadorId: insertForm().indicadorId, mesAno: $event, valor: insertForm().valor })"
          class="eco-input">
      </div>

      <div class="flex flex-column gap-1">
        <label class="eco-label">Valor Informado *</label>
        <input 
          type="number" 
          [ngModel]="insertForm().valor" 
          (ngModelChange)="insertForm.set({ indicadorId: insertForm().indicadorId, mesAno: insertForm().mesAno, valor: $event })"
          placeholder="0.00" 
          class="eco-input">
      </div>

      <div class="flex justify-content-end gap-2 pt-2">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeInsertModal()" />
        <p-button 
          label="Salvar Coleta" 
          icon="pi pi-check" 
          severity="primary" 
          size="small" 
          [disabled]="!insertForm().indicadorId || !insertForm().mesAno || insertForm().valor === null || submittingInsert()" 
          [loading]="submittingInsert()" 
          (onClick)="saveInsert()" />
      </div>
    </div>
  </p-dialog>

  <!-- Menu Drawer Mobile -->
  <p-drawer 
    [(visible)]="showMobileMenu" 
    position="right" 
    [style]="{ width: '280px', maxWidth: '85vw' }"
    [modal]="true">
    <ng-template #header>
      <div class="flex align-items-center gap-2">
        <div class="eco-brand-badge" style="width: 38px; height: 38px; min-width: 38px; min-height: 38px;">
          <img src="assets/ecodados-symbol.svg" alt="EcoDados Logo" style="width: 24px; height: 24px;">
        </div>
        <div class="flex flex-column">
          <span class="font-bold text-sm text-800">EcoDados</span>
          <span class="eco-meta">Navegação</span>
        </div>
      </div>
    </ng-template>

    <div class="flex flex-column justify-content-between h-full pt-3 pb-2">
      <div class="flex flex-column gap-2">
        <a routerLink="/coletas" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
          <span class="material-symbols-outlined text-xl text-teal-700">task_alt</span>
          <span>Minhas Coletas</span>
        </a>

        @if (role() === 'ADMIN') {
          <a routerLink="/indicadores" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
            <span class="material-symbols-outlined text-xl text-teal-700">tune</span>
            <span>Painel Admin</span>
          </a>

          <a routerLink="/analytics" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
            <span class="material-symbols-outlined text-xl text-teal-700">analytics</span>
            <span>Gráficos</span>
          </a>
        }
      </div>

      <!-- Rodapé do menu mobile -->
      <div class="border-t-1 border-teal-100 pt-3 flex flex-column gap-2">
        <div class="px-2 py-1 flex flex-column">
          <span class="text-xs font-bold text-800">{{ authService.currentUser()?.name }}</span>
          <span class="eco-meta">{{ role() === 'ADMIN' ? 'Administrador' : 'Responsável' }}</span>
        </div>
        <button (click)="logout()" class="eco-mobile-nav-link text-red-700 hover:bg-red-50 cursor-pointer border-none bg-transparent w-full text-left">
          <span class="material-symbols-outlined text-xl text-red-600">logout</span>
          <span>Sair do sistema</span>
        </button>
      </div>
    </div>
  </p-drawer>
</div>
